import React from "react";
import PropTypes from "prop-types";
import SVG from '../svg/Svg.tsx'


const SquareButton = ({ onClick, icon, background, border, size }) => {
  return (
    <button
      onClick={onClick}
      style={{
        background: background,
        border: border || 'none',
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: size,
        width: size,
        aspectRatio: "1 / 1", // Делаем кнопку квадратной
        cursor: "pointer",
      }}
    >

      {icon && (
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: size || "60%",
          height: size || "60%",
        }} >
          {SVG[icon]}
        </div>
      )}

    </button>
  );
};

// Пропсы компонента
SquareButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired, // Теперь icon — это строка (путь к SVG)
  backgroundColor: PropTypes.string,
};

export default SquareButton;
